import React from 'react';
import './SinglePort.css'

const SinglePort = (props) => {
    const { title, image, code, live } = props.portfolio;
    return (


        <div className="col-lg-4 col-md-12 col-sm-12 my-4">
            <div className="card portfolio-card">
                <img src={image} alt="..." />
                <div className="card-body bg-dark">
                    <h5 className="card-title text-center mb-5 text-danger custom-title fw-bold">Project Name: <span className=' text-light'>{title}</span> </h5>
                    <div>
                        <div className="row container ms-5">
                            <div className="col-lg-6  text-danger">
                                <div className="btn btn-danger my-2"> <a className="text-decoration-none text-light" target='_blank' href={live}>Live Link</a></div>
                            </div>
                            <div className="col-lg-6  text-danger">
                                <div className="btn btn-danger my-2"> <a className="text-decoration-none text-light" target='_blank' href={code}>Code Link</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    );
};

export default SinglePort;